import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/operator/switchMap';
import {
    ACTION_MONITORINGISSUEDOCUMENT_CREATE,
    ACTION_MONITORINGISSUEDOCUMENT_LOAD,
    ACTION_MONITORINGISSUEDOCUMENT_LOAD_BY_ID,
    ACTION_MONITORINGISSUEDOCUMENT_SAVE,
    ACTION_MONITORINGISSUEDOCUMENT_VALIDATE,
    ACTION_MONITORINGISSUEDOCUMENTS_LOAD_BY_MONITORINGISSUE_ID,

    IMonitoringIssueDocumentCreateAction,
    IMonitoringIssueDocumentCreateFailureAction,
    IMonitoringIssueDocumentCreateSuccessAction,
    IMonitoringIssueDocumentLoadAction,
    IMonitoringIssueDocumentLoadByIdAction,
    IMonitoringIssueDocumentLoadFailureAction,
    IMonitoringIssueDocumentLoadSuccessAction,
    IMonitoringIssueDocumentSaveAction,
    IMonitoringIssueDocumentSaveFailureAction,
    IMonitoringIssueDocumentSaveSuccessAction,
    IMonitoringIssueDocumentValidateAction,
    IMonitoringIssueDocumentValidateFailureAction,
    IMonitoringIssueDocumentValidateSuccessAction,
    IMonitoringIssueDocumentsLoadByMonitoringIssueIdAction,

    CreateFailure,
    CreateSuccess,
    LoadFailure,
    LoadSuccess,
    SaveFailure,
    SaveSuccess,
    ValidateFailure,
    ValidateSuccess,
} from "../actions/monitoringIssueDocument";
import { monitoringIssueDocumentsApi } from "../services/monitoringIssueDocuments";

export const
    getMonitoringIssueDocumentsEpic = (action$): Observable<IMonitoringIssueDocumentLoadSuccessAction | IMonitoringIssueDocumentLoadFailureAction> => {
        return action$
            .ofType(ACTION_MONITORINGISSUEDOCUMENT_LOAD)
            .mergeMap((_action: IMonitoringIssueDocumentLoadAction) => {
                return monitoringIssueDocumentsApi
                    .getMonitoringIssueDocuments()
                    .map(response =>
                        LoadSuccess(response.monitoringIssueDocuments, undefined, [], response.lookups, undefined)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getMonitoringIssueDocumentsByMonitoringIssueIdEpic = (action$): Observable<IMonitoringIssueDocumentLoadSuccessAction | IMonitoringIssueDocumentLoadFailureAction> => {
        return action$
            .ofType(ACTION_MONITORINGISSUEDOCUMENTS_LOAD_BY_MONITORINGISSUE_ID)
            .mergeMap((action: IMonitoringIssueDocumentsLoadByMonitoringIssueIdAction) => {
                return monitoringIssueDocumentsApi
                    .getMonitoringIssueDocumentsByMonitoringIssueId(action.monitoringIssueId)
                    .map(response =>
                        LoadSuccess(response.monitoringIssueDocuments, null, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    getMonitoringIssueDocumentsByIdEpic = (action$): Observable<IMonitoringIssueDocumentLoadSuccessAction | IMonitoringIssueDocumentLoadFailureAction> => {
        return action$
            .ofType(ACTION_MONITORINGISSUEDOCUMENT_LOAD_BY_ID)
            .mergeMap((action: IMonitoringIssueDocumentLoadByIdAction) => {
                return monitoringIssueDocumentsApi
                    .getMonitoringIssueDocumentById(action.id)
                    .map(response =>
                        LoadSuccess(response.monitoringIssueDocument, response.formState, response.formProperties, response.lookups, response.responseStatus)
                    )
                    .catch(error =>
                        Observable.of(LoadFailure(error.responseStatus))
                    )
            });
    },
    setMonitoringIssueDocumentEpic = (action$): Observable<IMonitoringIssueDocumentSaveSuccessAction | IMonitoringIssueDocumentSaveFailureAction> => {
        return action$
            .ofType(ACTION_MONITORINGISSUEDOCUMENT_SAVE)
            .mergeMap((action: IMonitoringIssueDocumentSaveAction) => {
                return monitoringIssueDocumentsApi
                    .setMonitoringIssueDocument(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return SaveFailure(response.responseStatus)
                        }

                        return SaveSuccess(response.monitoringIssueDocument, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(SaveFailure(error.responseStatus))
                    )
            });
    },
    createMonitoringIssueDocumentEpic = (action$): Observable<IMonitoringIssueDocumentCreateSuccessAction | IMonitoringIssueDocumentCreateFailureAction> => {
        return action$
            .ofType(ACTION_MONITORINGISSUEDOCUMENT_CREATE)
            .mergeMap((action: IMonitoringIssueDocumentCreateAction) => {
                return monitoringIssueDocumentsApi
                    .createMonitoringIssueDocument(action.monitoringIssueId)
                    .map(response =>
                        CreateSuccess(response.monitoringIssueDocument, response.formState, response.formProperties, response.lookups)
                    )
                    .catch(error =>
                        Observable.of(CreateFailure(error.responseStatus))
                    )
            });
    },
    validateMonitoringIssueDocumentEpic = (action$): Observable<IMonitoringIssueDocumentValidateSuccessAction | IMonitoringIssueDocumentValidateFailureAction> => {
        return action$
            .ofType(ACTION_MONITORINGISSUEDOCUMENT_VALIDATE)
            .mergeMap((action: IMonitoringIssueDocumentValidateAction) => {
                return monitoringIssueDocumentsApi
                    .validateMonitoringIssueDocument(action.formData)
                    .map(response => {
                        if (response.responseStatus &&
                            response.responseStatus.meta &&
                            response.responseStatus.meta.blockSave &&
                            response.responseStatus.meta.blockSave == "1") {
                            return ValidateFailure(response.responseStatus)
                        }

                        return ValidateSuccess(response.monitoringIssueDocument, response.formState, response.responseStatus)

                    })
                    .catch(error =>
                        Observable.of(ValidateFailure(error.responseStatus))
                    )
            });
    }